import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DbUser } from '../types/user';
import UserService from '../http/user-service';

export default class UserStore {
    private _loading = false;
    private _user: DbUser | null = null;
    constructor() {
        makeObservable<UserStore, '_loading' | '_user'>(this, {
            _loading: observable,
            _user: observable,
            loading: computed,
            user: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get user(): DbUser | null {
        return this._user;
    }

    async load(userId: number) {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await UserService.getById(userId);
            runInAction(() => {
                this._user = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }

    async edit(user: DbUser) {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await UserService.edit(user);
            runInAction(() => {
                this._user = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }

    async changePassword(pass: string, oldPass: string) {
        runInAction(() => {
            this._loading = true;
        });
        try {
            if (!this._user) throw Error('Пользователь не определен');
            await UserService.changePassword({
                ...this._user,
                password: pass,
                oldpassword: oldPass,
            });
            this.load(this._user.user_id);
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
